import {Box, Grid} from "@mui/material";
import {useAppSelector} from "../../../Config/Hooks";
import TotalizerPlantSkid from "./TotalizerPlantSkid/TotalizerPlantSkid";
import SkidNodes from "./SkidNodes/SkidNodes";
import {QueryClient, QueryClientProvider} from "react-query";
import WeatherStationPlant from "./WeatherStationPlant/WeatherStationPlant";
import ErrorBoundaryChart from "../../../Shared/Error/ErrorBoudaryChart";

export default function DashboardPowerPlantSkidLayoutPage(){

    const { selectedSkid, selectedPowerPlant } = useAppSelector((state) => state.dashboard);
    const queryClient = new QueryClient();
    return(
        <>
            {/*<Box p={2} sx={{display: "none"}}>*/}
            {/*    <TotalizerPlantSkid skidId={selectedSkid.id}/>*/}
            {/*</Box>*/}
            {/*<Box p={2} style={{height: '800px'}}>*/}
                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={12} lg={10.3} xl={10.5}>
                        <SkidNodes skidId={selectedSkid.id} powerPlantId={selectedPowerPlant.id} />,
                    </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={1.7} xl={1.5}>
                            <QueryClientProvider client={queryClient}>
                                <ErrorBoundaryChart key={selectedSkid.id} chartName={"Dados instantâneos"}>
                                    <WeatherStationPlant powerPlantId={selectedPowerPlant.id} skidId={selectedSkid.id}/>
                                </ErrorBoundaryChart>
                            </QueryClientProvider>
                        </Grid>
                </Grid>

            {/*</Box>*/}
        </>

    );
}
